
import alt from "../alt";

import ProductSource from '../sources/ProductSource.js';
import SuggestionSource from '../sources/SuggestionSource.js';
import ContactSource from '../sources/ContactSource.js';

import 'whatwg-fetch';

import ReactGA from "react-ga";
ReactGA.initialize('UA-376519-1', {
  titleCase: false
});

ReactGA.plugin.require('ec') 

if(typeof window.dataLayer == 'undefined') {
  window.dataLayer = [];
}

function getProductCategory (prod_key) {
	let category = '';
	if (prod_key.match('xgspon_fusion_preorder')) {
		category = 'XGSPON Pre-Order'
	} else if (prod_key.match('xgspon_standard_preorder')) {
		category = 'XGSPON Pre-Order'
	} else if (prod_key.match('xgspon')) {
		category = 'XGSPON'
	} else  if (prod_key.match('preorder')) {
		category = 'Fiber Pre-Order'
	} else if (prod_key.match('fiber')) {
		category = 'Fiber'
	} else if (prod_key.match('ipbb|fttn')) {
		category = 'IPBB'
	} else if (prod_key.match('voice_only')) {
		category = 'Voice'
	} else {
		category = 'DSL'
	}

	return category
}

function gaAddToCart (productAdded) {
	window.dataLayer.push ({
		'event': 'eec.add',
		'ecommerce': {
		  'add': {
			'actionField': {
			  'list': 'Shopping cart'
			},
			'products': [{
			  'id': productAdded.product_key,
			  'name': productAdded.product_name,
			  'category': getProductCategory(productAdded.product_key)
			}]
		  }
		}
	})
	window.dataLayer.push ({
		'event': 'eec.checkout',
		'ecommerce': {
		  'checkout': {
			'actionField': {
			  'step': '4'
			},
		  }
		}
	})
}

function gaImpressions (avail_products) {

	let category = ''
	let productDetails = []
	avail_products.forEach( product => {
		// Get the category that matches Marketings regex used in Google Analytics
		// Note that Marketing uses !fiber|ibpp|fttn which here is the else.
		
		category = getProductCategory(product.product_key)

		productDetails.push ({
			'id': product.product_key,
			'name' : product.product_name,
			'category': category
		})

		if ('undefined' !== typeof _paq) {
			_paq.push(['trackEvent', 'signup', 'QualResults', category + 'Prequal' ]);
		}
	})
	window.dataLayer.push({
		'event' : 'eec.productDetail',
		'ecommerce' : {
			'detail' : {
				'actionField' : {'list' : 'Products'},
				'products' :	productDetails
			}
		}
	});
	window.dataLayer.push ({
		'event': 'eec.checkout',
		'ecommerce': {
		  'checkout': {
			'actionField': {
			  'step': '3'
			},
		  }
		}
	})
	ReactGA.plugin.execute('ec', 'setAction', 'details', productDetails)
}

function gaEvent(category, action, label) {
  window.dataLayer.push({
  	event: category+"_"+action,
    category: category,
    action: action,
    label: label
  });

  ReactGA.event({
    category: category,
    action: action,
    label: label
  });
}


function PrequalException(value) {
	this.value = value;
	this.message = "Received an invalid response from the server.";
}

class AvailabilityActions {

	loadedAvailForm(auto_prequal_state) {
		if(!auto_prequal_state) {
			window.dataLayer.push ({
				'event': 'eec.checkout',
				'ecommerce': {
				'checkout': {
					'actionField': {
					'step': '1'
					},
				}
				}
			})	
		}
		return true;
	}

	showAdditionalProducts() {
		return true;
	}

	showVoiceOnly() {
		return true;
	}

	setPreOrderCollapseState(collapse_state) {
		return collapse_state;
	}

	selectSquallSuggestion(i) {
		return i;
	}
	
	serviceAvailable(data) {
		var label = this._serviceAvailableLabel(data);
		if(label == 'qual_error') {

			var error_code = '';

			if(typeof data != 'undefined' && typeof data.result != 'undefined' && typeof data.result.response != 'undefined' && typeof data.result.response.error_code != 'undefined' && data.result.response.error_code) {
				error_code = data.result.response.error_code;
			}
			else {
				error_code = 'invalid_response'
			}

			gaEvent("sp_availability", label, error_code);
		}
		else {
			gaEvent("sp_availability", label);

			// SP-2580
			if(typeof data.result != 'undefined' 
				&& typeof data.result.response != 'undefined' 
				&& typeof data.result.response.products_available != 'undefined' 
				&& typeof data.result.response.products_available.fusion != 'undefined'
			) {
				var coupons = Object.values(data.result.response.products_available.fusion)
					.map(function(product) {
						return (typeof product.promo != 'undefined' ? product.promo.code : null);
					})
					.filter(function(value, index, self) {
						// https://stackoverflow.com/a/14438954
						return self.indexOf(value) === index;
					});

				for(var i = 0; i < coupons.length; i++) {
					gaEvent('coupon', 'returned', coupons[i]);
				}
				data.result.response.products_available.fusion.forEach(function(product) {
                	gaEvent('sp_availability', 'productshown', product.product_key);
				});
				
				gaImpressions (data.result.response.products_available.fusion);
			}

			if(typeof data.availability != 'undefined' && label == 'qual_home_success') {
				// placeholders for further experiments
			}
		}

		if(!data.result || typeof data.result == 'undefined') {
			return [];
		}

		return data.result;
	}

	_serviceAvailableLabel(data) {

		var label;

    	if(typeof data == 'undefined' || typeof data.result == 'undefined' || typeof data.result.response == 'undefined' || data.result.status == 'ERROR') {
    		return 'qual_error';
    	}

	    if(data.result.response.service_available) {

		    if(data.result.response.products_available.reseller) {
		      return 'qual_reseller';
		    }

	    	if(data.request.service_type == 'small_business') {
	    		return 'qual_businesssmall_success';
	    	}
	    	else if(data.request.service_type == 'residential') {
	    		return 'qual_home_success'
	    	}
	    	else {
	    		return 'qual_business_success';
	    	}
	    }
	    else {
	    	if(data.request.service_type == 'business') {
	    		return 'qual_busnotyet';
	    	}
	    	else {
	    		return 'qual_resnotyet';
	    	}
	    }
	}

	updateProducts(result) {
		return result;
	}

	updateServiceType(service_type) {
		return service_type;
	}

	addressVerified(candidate) {
		return candidate;
	}

	closeMduModal() {
		return true;
	}

	openMduModal() {
		return true;
	}


	backToStepOne() {
		gaEvent("sp_availability", "back_to_step1");
		if ('undefined' !== typeof grecaptcha) {
			window.token = '';
		}
		return true;
	}

	notMyAddr() {
		gaEvent("sp_availability", "not_my_addr");
		
		if ('undefined' !== typeof grecaptcha) {
			window.token = '';
		}
		return true;
	}

	businessNotMyAddr()
	{
		gaEvent('Business Availability Page', 'Button Click', 'Not My Address');
		this.notMyAddr();
	}

	placeOrder() {
		return (dispatch) => {
			dispatch();

			this.orderPlaced();

			gaEvent("sp_availability", "res_handoff");

			return false;
		}
	}

	orderPlaced() {
		return true;
	}

	updateBusinessSeats(seats) {
		return seats;
	}

	continueToConfigure() {
		return true;
	}

	continuePrequal(availability) {
		return availability;
	}

	setVideoPlaying(state) {
		return state;
	}

    setBailOutForm(state) {
		return state;
	}

    setPrequalStage(state) {
		return state;
	}

	showMoreFields(availability) {
		return availability;
	}

	closeSquallMduModal(availability) {
	    if(availability.lastPrequal.request.secondary != availability.input_address.secondary) {
	    	this.prequalStart(availability);
	    }
		return availability;
	}
	
	closeSquallSuggestionsModal(availability) {
		this.prequalStart(availability);
		return availability;
	}

	gotForm(form) {
		return form;
	}

	showBusinessType() {
		return true;
	}

	hideBusinessType() {
		return true;
	}

	reQualSmallBusiness() {

		gaEvent('Business Availability Page', 'Button Click', 'Type: Small Business');
		return true;
	}

	prequalStart(availability) {

		if(!availability.input_address.streetAddress_valid || !availability.input_address.zip_valid) {
			return false;
		}

		if(!availability.input_address.verificationRan) {
			this.verifyInput(availability, true);
			return false;
		}

		if(!availability.sso_user && !window.token) {
			if ('undefined' !== typeof grecaptcha && 'function' === typeof grecaptcha.reset) {
				grecaptcha.reset();
				grecaptcha.execute();
				return false;
			}
		}
		
		if(availability.input_address.serviceType != 'business') {
			this.hideBusinessType();
		} else {
			gaEvent('Business Availability Page', 'Button Click', 'Check Availability');
		}

		return (dispatch) => {
		    // we dispatch an event here so we can have "loading" state.
		    // this is probably not necessary for what we do here...
		    dispatch();

		    if(Object.keys(availability.verified_address).length !== 0 
		      && availability.verified_address.constructor === Object      
		      && typeof availability.verified_address.analysis.footnotes != 'undefined' 
		      && availability.verified_address.analysis.footnotes.indexOf('H#') != -1
		      && availability.input_address.secondary == ''
		      && availability.mduModalDismissed === false
		    ) {
		    	this.openMduModal();
		      return false;
		    }

		    gaEvent("sp_availability", "prequal_start");
		    this.prequalStarted(true);

			var aa = this;

			var coupon_code = (typeof availability.coupon != 'undefined' ? availability.coupon.code : '')

		    ProductSource.prequalStart(availability.input_address, availability.sso_user, coupon_code, availability.referral_code, availability.sonic_elq_customerID, availability.exposure, availability.api_path, availability.return_suggestions)
		    .then((result) => {
		        // we can access other actions within our action through `this.actions`
		        //this.updateProducts(suggestions);
		        // if products available update products
		        // result.metadata.response_tracking_key

		        // if you get an error here, handle it
		        // as in, if there's no metadata and no tracking key

                // This error occurs because the sso_user is set, and user is NOT on VPN. Show this error so internal users know what to do.
                if ('undefined' !== typeof result.internal && result.internal) {
                    alert("Authentication Error!\n\nYou are logged in with an SSO session but are off-network. Please check your network connection or try again using a private browsing session.");
                }
		        if(!result.metadata) {
				throw new PrequalException(result);
		        }

		        window.dataLayer.push({
		        	prequal_key: result.metadata.response_tracking_key
		        });

				var poll_interval = 750;
				var poll_complete = false;
				var poll_starttime = new Date().getTime() / 1000;
				var poll_stage = 0;

				// poll until it finishes, then run


				(function poll(){
				    setTimeout(function(){
						ProductSource.prequalPoll(availability.input_address, result.metadata.response_tracking_key, availability.sso_user, coupon_code, availability.sonic_elq_customerID, availability.api_path)
						.then((data) => {

                            if(poll_complete) {
                                return;
                            }

                            if(!data.result || !data.result.metadata) {
                                throw new PrequalException(data);
                            }

                            var seconds_since_start = (new Date().getTime() / 1000) - poll_starttime;

                            if(data.response == 'ready') {
                                // fire off that the prequal has finished, include the payload
                                data.result.async_id = result.metadata.response_tracking_key;
                                data.availability = availability;
                                aa.serviceAvailable(data);

                                poll_complete = true;
                                return;
                            }
                            else {
                                // fire off that the prequal has not finished
                                aa.prequalNotReady();
                            }

                            // it's been 5 minutes, don't poll again
                            if(seconds_since_start > 300) {
                                throw new PrequalException(data);
                            } else if (seconds_since_start > 60 ) { // More than a seconds slow down polling.
                                poll_interval = 1500;
                            } 

                            poll();
						})
						.catch((exception) => {
								console.log('error', exception);
								aa.serviceAvailable(exception.value);
						});
                    }, poll_interval);
                })();				

            })
            .catch((exception) => {
                console.log('error', exception);
                this.serviceAvailable(exception.value);
            });
	    }
	}

	selectProduct(product) {

		gaEvent("sp_availability", "productselected", product.product_key);

		gaAddToCart (product);

		return product;
	}

	prequalStarted() {
		// do something with the state of the app store
		return 'prequalStarted';
	}


	prequalNotReady() {
		return 'not ready';
	}

	updateSuggestions(suggestions) {
		return suggestions;
	}

	updateGeoSuggest(component, value) {
		component.update(value);
		return true;
	}

	updateStreetAddress(streetAddress) {
		return streetAddress;
	}

	updateSecondary(secondary) {
		return secondary;
	}

	updateZip(zip) {
		return zip;
	}
	
	suggestionSelected(suggestion) {
		return suggestion;
	}

	verificationFailed(errorMessage) {
		return errorMessage;
	}

	verifySuggestion(suggestion) {
		return (dispatch) => {
			dispatch();
			// verifySuggestion gets dispatched here, so we can display a loading spinner if we maybe set the state to 'verifying' or something
			var components = {};
    		var gmaps = suggestion.gmaps.address_components;
    		var foundStreet = false;

    		for(var i in gmaps) {
			      if(!gmaps[i] || typeof gmaps[i] == 'function' || !gmaps[i].types) {
			        continue;
			      }
				components[gmaps[i].types[0]] = gmaps[i].short_name;
				if (gmaps[i].types[0] == 'street_number') {
					foundStreet = true;
				}
			}

    		if (!foundStreet) {
			      // usually happens if the street # is invalid, or possibly if unknown to google places (new developments)
			      components.street_number = '';
			      var match = suggestion.label.match(/^([\d\w]+)/);
			      if (null !== match) {
				      components.street_number = match[1];
				  }
			}

			var addr_to_verify = {
		      street_line: components.street_number + ' ' + components.route,
		      city: components.locality,
		      state: components.administrative_area_level_1,
		      zipcode: components.postal_code,
		      suggestion: components
			}

		    SuggestionSource.verify(addr_to_verify)
		      .then((candidates) => {
		        // we can access other actions within our action through `this.actions`
		        this.addressVerified({
		        	candidates: candidates,
		        	addr_to_verify: addr_to_verify
		        });
		        // address needs to be marked as verified
		      })
		      .catch((errorMessage) => {
		      	console.log('verification failed', errorMessage);
		        this.verificationFailed(errorMessage);
		      });

		}
	}

	verifyInput(availability, fromPrequalStart) {
		var streetAddress = availability.input_address;

		return (dispatch) => {
			dispatch();
		    if(!streetAddress.verified && !streetAddress.verificationRan && streetAddress.streetAddress && streetAddress.zip) {
		    	var addr_to_verify = {
		    		street_line: streetAddress.streetAddress,
		    		zipcode: streetAddress.zip 
		    	}

			    SuggestionSource.verify(addr_to_verify)
			      .then((candidates) => {
			        // we can access other actions within our action through `this.actions`

			        // add console.log here 
			        this.addressVerified({
			        	candidates: candidates,
			        	addr_to_verify: addr_to_verify
			        });

			        // @TODO change this...
			        // all of this logic gets handled in the store, and actually sets the state,
			        // but this is so we can fire the other action without having to reach into or wait for the store to update
				    if(!candidates.length) {
				      return;
				    }

				    var candidate = candidates[0];

				    availability.input_address.streetAddress = candidate.delivery_line_1;
				    availability.input_address.city = candidate.components.city_name;
				    availability.input_address.state = candidate.components.state_abbreviation;
				    availability.input_address.zip = candidate.components.zipcode;

				    if(!availability.service_type_manually_selected) {
				    	availability.input_address.serviceType = (candidate.metadata.rdi == 'Commercial' ? 'business' : 'residential');
				    }
				    availability.verified_address = candidate;

				    availability.input_address.verificationRan = true;
				    availability.input_address.verified = true;
				    availability.input_address.streetAddress_valid = true;
				    availability.input_address.zip_valid = true;

			      	if(availability.input_address.verified && fromPrequalStart) {
			      		this.prequalStart(availability);
		            } 
		            else {
			        	// AND add console.log here to figure out situations for which the first time this is called doesn't work...
                        this.addressVerified({
                            candidates: candidates,
                            addr_to_verify: addr_to_verify
                        });
                    }
			      })
			      .catch((errorMessage) => {
			        this.verificationFailed(errorMessage);
			      });
			      
			      return;
		    }		
		}
	}

	updateContactInfo(key, value) {
		var tuple = [key, value];
		return tuple;
	}

	validateContactInfo(availability) {
		return availability;
	}

	submitResContactMe(availability) {
		return (dispatch) => {
			dispatch();

		  	if(!availability.contact_info.is_valid) {
		  		return;
		  	}

			ContactSource.contactMe(availability)
			.then((result) => {
				gaEvent("sp_availability", "resnotyetthanks")
				this.contactMeSuccess(result);
			})
			.catch((errorMessage) => {
				this.contactMeFailed(errorMessage);
			})
		}
	}

	submitBusContactMe(availability) {

		return (dispatch) => {
			dispatch();

		  	if(!availability.contact_info.is_valid) {
		  		console.log('invalid');
				gaEvent('Business Availability Page', 'Button Click', 'Build My Estimate: Invalid');
		  		return;
		  	}

			ContactSource.contactMe(availability)
			.then((result) => {
				this.contactMeSuccess(result);
				gaEvent('Business Availability Page', 'Button Click', 'Build My Estimate');
			})
			.catch((errorMessage) => {
				this.contactMeFailed(errorMessage);
				gaEvent('Business Availability Page', 'Button Click', 'Build My Estimate: Error');
			})
		}
	}

	contactMeSuccess(result) {
		return result;
	}

	contactMeFailed(errorMessage) {
		return errorMessage;
	}

	browseServiceOfferings() {
		gaEvent('Business Availability Page', 'Button Click', 'Browse Service Offerings');
	}
	

}

export default alt.createActions(AvailabilityActions);
